<template>
  <div class="language-switcher">
    <dx-button
      :text="$t('languages.english')"
      :class="['lang-button', { 'active-lang': currentLocale === 'en' }]"
      @click="changeLanguage('en')"
      styling-mode="text"
    />
    <dx-button
      :text="$t('languages.french')"
      :class="['lang-button', { 'active-lang': currentLocale === 'fr' }]"
      @click="changeLanguage('fr')"
      styling-mode="text"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DxButton from 'devextreme-vue/button'

export default {
  name: 'LanguageSwitcher',
  components: {
    DxButton
  },
  computed: {
    ...mapGetters('i18n', ['currentLocale'])
  },
  methods: {
    ...mapActions('i18n', ['setLocale']),
    async changeLanguage(locale) {
      try {
        await this.setLocale(locale)
        //this.$toast.success(this.$t('common.languageChanged'))
        // Reload page to ensure all components update
        window.location.reload()
      } catch (error) {
        this.$toast.error(this.$t('common.languageChangeError'))
      }
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
}

.language-switcher .dx-button {
  color: white !important;
}

.language-switcher .dx-button * {
  color: white !important;
}

.lang-button .dx-button-content {
  color: white !important;
  padding: 6px 12px;
}

.lang-button .dx-button-text {
  color: white !important;
}

.lang-button.active-lang {
  background-color: #f37021; /* The orange from the image */
}

.lang-button.active-lang .dx-button-content {
  color: white !important;
}

.lang-button.active-lang .dx-button-text {
  color: white !important;
}
</style>